<template>
  <div id="app" class="app">
    <router-view v-if="!isLogged" />
    <template v-else>
      <user-permissions />
      <ets-nav-bar section="admin" />
      <router-view />
    </template>
  </div>
</template>

<script>
import auth from "@/logic/auth";
import UserPermissions from "@/components/UserPermissions";

export default {
  name: "App",
  components: {
    UserPermissions
  },
  data: () => ({
    isLogged: auth.isLogged()
  }),
  beforeUpdate() {
    this.isLogged = auth.isLogged();
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "EAF";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  flex-direction: column;
}
</style>
